module.exports = __webpack_public_path__ + "static/media/arrowRightSolid.ac06e71a.svg";